define('drops/audioPlayer/audioPlayerNative',[
    "jquery", 
    "underscore", 
    "./audioPlayerBase"
], function ($, _, AudioPlayerBase) {
    "use strict";

    function AudioPlayerNative(drop) {
        AudioPlayerBase.call(this, drop);
    }

    AudioPlayerNative.prototype = Object.create(AudioPlayerBase.prototype);
    AudioPlayerNative.prototype.constructor = AudioPlayerNative;

    AudioPlayerNative.prototype.createAudioElement = function () {
        this.$audio = $("<audio controls />").css({
            width: "100%",
            height: "100%",
            display: "block",
        });
        this.audioElement = this.$audio.get(0);
        this.drop.$element.append(this.$audio);
        return this.audioElement;
    };

    AudioPlayerNative.prototype.initialize = function () {
        var self = this;

        if (!this.$audio) {
            this.createAudioElement();
        }

        var url = this.drop.getAudioUrl();

        this.$audio
            .prop("autoplay", !!(this.drop.data.autoPlay && url))
            .prop("loop", !!this.drop.data.loop)
            .prop("muted", !!this.drop.data.muted)
            .attr("preload", this.drop.data.preload || "metadata");

        if (url && this.$audio.attr("src") !== url) {
            this.$audio.attr("src", url);
        }

        this.bindAudioEvents();

        this.$audio.off(".audioplayernative");

        this.$audio.on("volumechange.audioplayernative", function () {
            if (self.audioElement) {
                var isMuted = self.audioElement.muted || self.audioElement.volume === 0;
                var vol = isMuted ? 0 : Math.round(self.audioElement.volume * 100);
                if (self.lastMutedState !== isMuted) {
                    self.lastMutedState = isMuted;
                    self.triggerEvent("muteToggled", isMuted);
                }
                if (self.lastReportedVolume !== vol) {
                    self.lastReportedVolume = vol;
                    self.triggerEvent("volumeChanged", vol);
                }
            }
        });

        this.$audio.on("seeked.audioplayernative", function () {
            if (self.audioElement) {
                self.triggerEvent("seekChanged", self.audioElement.currentTime);
            }
        });
    };

    AudioPlayerNative.prototype.dispose = function () {
        if (this.$audio) {
            this.$audio.off(".audioplayernative");
        }
        AudioPlayerBase.prototype.dispose.call(this);
    };

    return AudioPlayerNative;
});

